import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        totalPlayers: 'Total Players',
        cardSetup: 'Card Setup',
      },
    },
    hy: {
      translation: {
        totalPlayers: 'Ընդհանուր խաղացողներ',
        cardSetup: 'Քարտերի կարգավորում',
      },
    },
  },
  lng: 'en', // Default language
  fallbackLng: 'en', // Fallback language if translation not found
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
